// Field metrics for the Actuals vs Budget configuration screen (IB-834 design):
// recessed grey controls on a white card, grouped into bordered zones, with
// 12.5px medium labels and 11.5px hints.
//
// Deliberately local to this screen rather than added to the global input classes
// (`.text-input`, `.select-input`) — those are shared app-wide, so restyling the
// report configuration must not reach any other form.

export const FIELD_LABEL = 'tw-block tw-mb-1.5 tw-text-[12.5px] tw-font-medium tw-text-charcoal';

const FIELD_BASE =
    'tw-w-full tw-bg-grey/50 tw-rounded-[9px] tw-text-[13.5px] tw-font-normal tw-text-charcoal tw-border-0 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-50 disabled:tw-text-charcoal-25 disabled:tw-cursor-not-allowed';

export const FIELD_INPUT = `${FIELD_BASE} tw-px-3 tw-py-2.5`;

// Selects leave room at the inline end for the chevron the forms plugin draws.
export const FIELD_SELECT = `${FIELD_BASE} tw-ps-3 tw-pe-10 tw-py-2.5`;

export const FIELD_HINT = 'tw-mt-1.5 tw-text-[11.5px] tw-leading-[1.45] tw-text-charcoal-50';

export const FIELD_ERROR = 'tw-mt-1.5 tw-text-[11.5px] tw-text-red';

export const ZONE = 'tw-rounded-xl tw-border tw-border-grey tw-px-5 tw-py-[18px]';

export const ZONE_TITLE = 'tw-mb-3.5 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-[0.8px] tw-text-charcoal-50';

export const ZONE_GRID = 'tw-grid tw-grid-cols-3 tw-gap-x-[26px] tw-gap-y-[18px]';
